<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card>
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="9"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>Grade 3 Rebuild Contact</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="4"
            vs-xs="12"
          >
          </vs-col>
        </vs-row>


<vs-popup
      title="Add Account"
       v-if="showAddAccountPopup"
      :active.sync="addAccountPopupActive"
      fullscreen
    >

    <div class="vx-col w-full mb-base m-10">
      <form data-vv-scope="AddAccountForm">

    <div class="vx-row mb-6"  v-show="isVisible">
            <div class="vx-col sm:w-1/5 w-full">
              <span>This Company is a Sole Trader:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- <input type="checkbox" v-model="IsSoleTrader"/> -->
              <vs-switch vs-icon-on="check_box" vs-icon-off="block" v-model="accounts.IsSoleTrader">
                <span slot="on">YES</span>
                <span slot="off">NO</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.company_name" v-model="accounts.company_name" v-validate="'required'"
                data-vv-as="Company Name" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('AddAccountForm.company_name')">{{
              errors.first("AddAccountForm.company_name") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Registration Number:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.company_registration_number" v-model="accounts.company_registration_number"
                v-validate="{ required: !this.accounts.IsSoleTrader }" data-vv-as="Company Registration Number" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('AddAccountForm.company_registration_number')">{{
              errors.first("AddAccountForm.company_registration_number") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Status:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.company_status" v-validate="'required'" v-model="accounts.status"
                data-vv-as="Company Status" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('AddAccountForm.company_status')">{{
              errors.first("AddAccountForm.company_status") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Category:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.company_category" v-model="accounts.company_category"
                data-vv-as="Company Category" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('AddAccountForm.company_category')">{{
              errors.first("AddAccountForm.company_category") }}</span>
          </div>
          <vs-divider class="m-5" />

          <!-- Registered Office -->
          <h5 class="mb-5">Registered Office Address</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 1:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.registered_office_address_1" v-model="accounts.registered_office_address_1" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 2:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.registered_office_address_2" v-model="accounts.registered_office_address_2" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 3:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.registered_office_address_3" v-model="accounts.registered_office_address_3" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>City:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.registered_office_city" v-model="accounts.registered_office_city" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>County:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.registered_office_county" v-model="accounts.registered_office_county" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Postcode:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.registered_office_postcode" v-model="accounts.registered_office_postcode" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Country:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">

              <AccountAutocomplete ref="accountAddRegisteredOfficeCountryRef" :chosen="selected_registered_office_country"
                class="searchbox" :list="getCountries" :searchOn="'registered_office_country'">
              </AccountAutocomplete>

              <!-- <vs-input
                class="w-full"
                name="AddAccountForm.registered_office_country"
                v-model="accounts.registered_office_country"
              /> -->
            </div>
            <span v-if="registered_office_country_validation" class="text-danger text-sm mt-2 ml-16">{{
              registered_office_country_validation }}</span>
          </div>
          <vs-divider class="m-5" />

          <!-- Head Office -->
          <h5 class="mb-5">Head Office Address</h5>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Head Office Address is the Same As the Registered Office
                Address:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- <input type="checkbox" v-model="headOfficeIsRegisteredOffice"/> -->
              <vs-switch vs-icon-on="check_box" vs-icon-off="block" v-model="accounts.headOfficeIsRegisteredOffice">
                <span slot="on">YES</span>
                <span slot="off">NO</span>
              </vs-switch>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 1:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accounts.head_office_address_1" name="head_office_address_1" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 2:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.head_office_address_2" v-model="accounts.head_office_address_2" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 3:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.head_office_address_3" v-model="accounts.head_office_address_3" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>City:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.head_office_city" data-vv-as="City" v-model="accounts.head_office_city" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>County:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="AddAccountForm.head_office_county" v-model="accounts.head_office_county" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Postcode:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accounts.head_office_postcode" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Country:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete ref="accountAddHeadOfficeCountryRef" :chosen="selected_head_office_country"
                class="searchbox" :list="getCountries" :searchOn="'head_office_country'">
              </AccountAutocomplete>




              <!-- <vs-input class="w-full" v-model="accounts.head_office_country" /> -->
            </div>
            <span v-if="head_office_country_validation" class="text-danger text-sm mt-2 ml-16">{{
              head_office_country_validation }}</span>

          </div>
          <vs-divider class="m-5" />
          <!-- Head Office -->
          <h5 class="mb-5">Company Website(s)</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input class="w-full" name="web" v-model="accounts.web" v-validate="'url:require_protocol'"
                data-vv-as="Website" />
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button @click="addWebsite" color="primary" type="filled">Add</vs-button>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('web')">{{ errors.first("web") }}</span>
            </div>
          </div>
          <template v-if="accounts.websites.length > 0">
            <vs-divider class="p-5" />
            <h6 class="mb-2">Added Website URLs</h6>
          </template>

          <template v-for="(website, index) in accounts.websites">
            <span class="p-5">
              <p>
                {{ website }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedWeb(website)" color="success"
                  icon="clear"></vs-icon>
              </p>
            </span>
          </template>
          <vs-divider class="m-5" />
          <!-- Head Office -->
          <h5 class="mb-5">Social Media Pages</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input class="w-full" name="linkedin" v-validate="'url:require_protocol'" v-model="accounts.linkedin" />
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="addLinkedin" type="filled">Add</vs-button>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('linkedin')">{{ errors.first("linkedin")
              }}</span>

            </div>
          </div>
          <template v-if="accounts.linkedins.length > 0">
            <vs-divider class="p-5" />
            <h6 class="mb-2">Added LinkedIn/Social URLs</h6>
          </template>

          <template v-for="(link, index) in accounts.linkedins">
            <span :key="index" class="p-5">
              <p>
                {{ link }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedLinkedin(link)" color="success"
                  icon="clear"></vs-icon>
              </p>
            </span>
          </template>
          <vs-divider class="m-5" />

          <!-- Site Office -->
          <h5 class="mb-5">Site Office Address</h5>
          <template v-for="(site, index) in accounts.satellite">
            <div :key="index">
              <vs-divider class="m-5" />
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 1:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" name="satellite_office_address_1" data-vv-as="Address Line 1"
                    v-model="site.address_1" />
                </div>
                <vs-icon v-if="index > 0" class="ml-10 removeButton" @click="removeSelectedSiteAddress(site)"
                  color="success" icon="clear"></vs-icon>

              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 2:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.address_2" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 3:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.address_3" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>City:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.city" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>County:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.county" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Postcode:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.postcode" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Telephone:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/2 w-full">                  <v-select name="phone_code" class="phone_code" label="name_with_code"
                                    :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="site.phone_code" />
</div>
                    <div class="vx-col sm:w-1/2 w-full">                  <vs-input @input="site.phone = site.phone.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" class="w-full" v-model="site.phone" />
</div>

                  </div>
                </div>
              </div>




            </div>
          </template>
          <vs-col class="mb-5" vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
            <vs-button color="primary" @click="addSiteOffice" type="filled">Add Satellite Office</vs-button>
          </vs-col>

          <vs-divider class="m-5" />

          <!-- Telephone -->
          <h5 class="mb-5">Telephone Number(s)</h5>
          <div class="vx-row mb-6">
           
            <div class="vx-col sm:w-1/6 w-full">
              <v-select name="phone_code" class="phone_code" label="name_with_code"
                                    :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="accounts.phone_code" />
              <!-- <vs-input class="w-full" v-model="accounts.phone" /> -->
            </div>
           
           
           
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input @input="accounts.phone = accounts.phone.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" class="w-full" v-model="accounts.phone" />
            </div>


            <div class="vx-col sm:w-1/5 w-full">
              <v-select label="name" :options="accounts.phoneTypes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="accounts.phoneType" />
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="addPhoneNumbers" type="filled">Add</vs-button>
            </div>
          </div>
          <template v-if="accounts.joinedPhoneAndTypes.length > 0">
            <vs-divider class="p-5" />
            <h6 class="mb-2">Added Phone Numbers</h6>
          </template>

          <template v-for="(phoneAndType, index) in accounts.joinedPhoneAndTypes">
            <span :key="index" class="p-5">
              <p>
                {{ phoneAndType }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedPhone(phoneAndType)" color="success"
                  icon="clear"></vs-icon>
              </p>
              <!-- <p>{{ phoneAndType }}</p> -->
            </span>
          </template>

          <!-- SIC CODE -->
          <h5 class="mb-5">Sic Code(s)</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">

              <AccountAutocomplete ref="SicCodeRef" class="searchbox" :chosen="selected_sic_code" :list="getSicCodes"
                :searchOn="'sic_codes'"></AccountAutocomplete>

              <!-- <vs-input type="number" class="w-full" v-model="accounts.sic_code" /> -->
            </div>
            <!-- <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accounts.sic_code_description" />
            </div> -->
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="addSicCode" type="filled">Add</vs-button>
            </div>
          </div>
          <template v-if="accounts.joinedSicAndDescription.length > 0">
            <vs-divider class="p-5" />
            <h6 class="mb-2">Added Sic Codes</h6>
          </template>

          <template v-for="(sic, index) in accounts.joinedSicAndDescription">
            <span :key="index" class="p-5">
              <p>
                {{ sic }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedSic(sic)" color="success"
                  icon="clear"></vs-icon>
              </p>
            </span>
          </template>
          <vs-divider class="m-5" />
          <h5 class="mb-5">Other Details</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Registration Jurisdiction:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete ref="RegistrationJurisdictionRef" :chosen="selected_registration_jurisdiction"
                class="searchbox" :list="getCountries" :searchOn="'registration_jurisdiction'">
              </AccountAutocomplete>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Parent Company:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete ref="ParentRef" class="searchbox" :chosen="selected_parent_company"
                :list="getParentCompany" :searchOn="'parent'"></AccountAutocomplete>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Vertical:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete ref="VerticalRef" class="searchbox" :chosen="selected_vertical" :list="getVerticals"
                :searchOn="'vertical'"></AccountAutocomplete>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Revenue:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select label="label" :options="currencyCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="accounts.currency_code" />
                </div>

                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input type="number" class="w-full" v-model="accounts.revenue" />
                </div>
              </div>
              <span v-if="currency_code_validation" class="text-danger text-sm mt-2 ml-16">{{ currency_code_validation
              }}</span>


            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>No. of Employees:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input class="w-full" type="number" v-model="accounts.no_of_employees" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Notes:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-textarea class="w-full mb-2" v-model="accounts.notes" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="addAccountForm">Submit</vs-button>
            </div>
          </div>
      </form>
   
    </div>


    </vs-popup>


       <template v-if="accountExists">
        <vs-popup fullscreen :title="companyExistsAccountDescription.company_name" :active.sync="popupActive">
          <div class="flex justify-between flex-wrap">
            <vs-button class="mb-4 mr-6" @click="accept()" type="border">Accept</vs-button>
            <vs-button class="mb-4" type="border" @click="reject()" color="primary">Reject</vs-button>
          </div>
          <vs-list>
            <vs-list-header title="Key Company Details" color="success"></vs-list-header>
            <vs-list-item title="Company Name ">
              {{ companyExistsAccountDescription.company_name }}
            </vs-list-item>
            <vs-list-item title="Company Registration Number">
              {{ companyExistsAccountDescription.company_registration_number }}
            </vs-list-item>
            <vs-list-item title="Switchboard">
              <template v-for="(ph, index) in companyExistsAccountDescription.phone">
                <div :key="index">
                  <template v-for="(ph_type, index2) in ph.phone_type">
                    <div :key="index2" v-if="
                      ph_type.type == 'Switchboard' &&
                      ph_type.phone_id == ph.id
                    ">
                      {{ ph.phone_no }}
                    </div>
                  </template>
                </div>
              </template>
            </vs-list-item>
            <vs-list-item title="Site Switchboard">
              <template v-for="(ph, index) in companyExistsAccountDescription.phone">
                <div :key="index">
                  <template v-for="(ph_type, index2) in ph.phone_type">
                    <div :key="index2" v-if="
                      ph_type.type == 'Site Switchboard' &&
                      ph_type.phone_id == ph.id
                    ">
                      {{ ph.phone_no }}
                    </div>
                  </template>
                </div>
              </template>
            </vs-list-item>
            <vs-list-item title="Others">
              <template v-for="(ph, index) in companyExistsAccountDescription.phone">
                <div :key="index">
                  <template v-for="(ph_type, index2) in ph.phone_type">
                    <div :key="index2" v-if="
                      ph_type.type == 'Others' &&
                      ph_type.phone_id == ph.id
                    ">
                      {{ ph.phone_no }}
                    </div>
                  </template>
                </div>
              </template>
            </vs-list-item>
          </vs-list>

          <vs-list>
            <vs-list-header title="Address" color="success"></vs-list-header>
            <vs-list-item title="Head Office Address">
              {{ companyExistsAccountDescription.head_office_address_1 }}
              {{ companyExistsAccountDescription.head_office_address_2 }}
              {{ companyExistsAccountDescription.head_office_address_3 }}
              {{ companyExistsAccountDescription.head_office_city }}
              {{ companyExistsAccountDescription.head_office_postcode }}
              {{ companyExistsAccountDescription.head_office_county }}
              {{ companyExistsAccountDescription.head_office_country }}
            </vs-list-item>
            <vs-list-item title="Registered Office Address">
              {{ companyExistsAccountDescription.registered_office_address_1 }}
              {{ companyExistsAccountDescription.registered_office_address_2 }}
              {{ companyExistsAccountDescription.registered_office_address_3 }}
              {{ companyExistsAccountDescription.registered_office_city }}
              {{ companyExistsAccountDescription.registered_office_postcode }}
              {{ companyExistsAccountDescription.registered_office_county }}
              {{ companyExistsAccountDescription.registered_office_country }}
            </vs-list-item>
            <template v-for="(satellite, index) in companyExistsAccountDescription.satellite_office">
              <vs-list-item :title="'Satellite Office ' + (index + 1)" :key="index">
                <template v-for="(phone, index3) in satellite.phone">
                  <div :key="index3" v-if="phone.satellite_office_id == satellite.id">
                    {{ phone.phone_no }}
                  </div>
                </template>
                {{ satellite.address_1 }}
                {{ satellite.address_2 }}
                {{ satellite.address_3 }}
                {{ satellite.town }}
                {{ satellite.county }}
                {{ satellite.postcode }}

                <template v-for="(country, index2) in satellite.country">
                  <div :key="index2" v-if="country.satellite_office_id == satellite.id">
                    {{ country.name_1 }}
                    {{ country.name_2 }}
                    {{ country.name_3 }}
                  </div>
                </template>
              </vs-list-item>
            </template>
          </vs-list>

          <vs-list>
            <vs-list-header title="Websites" color="success"></vs-list-header>
            <template v-for="(web, index) in companyExistsAccountDescription.web">
              <div :key="index">
                {{ web.url }}
              </div>
            </template>
          </vs-list>
          <vs-list>
            <vs-list-header title="LinkedIn" color="success"></vs-list-header>
            <template v-for="(linkedin, index) in companyExistsAccountDescription.linkedin">
              <div :key="index">
                {{ linkedin.url }}
              </div>
            </template>
          </vs-list>
        </vs-popup>
      </template>



         <vs-popup
      title="Account Details"
       v-if="showUpdateSAccountDetailsPopup"
      :active.sync="updateAccountDetailsPopupActive"
      :button-close-hidden="true"
          @close="closUpdateSAccountDetailsPopup"
    >


     <div class="text-center">

     <vs-button color="primary" @click="confirmAccountSelection" type="filled"
                >Submit</vs-button
              >

              <vs-button color="primary" @click="cancelAccountSelection" type="filled" class="ml-5"
                >Cancel</vs-button
              >

</div>

   
      <div class="p-5">
       


     
 
        <div class="vx-row mb-6" v-if="viewAccountDescription.company_name">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Company Name:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.company_name }}
          </div>
         
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.actual_account_name">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Actual Account Name:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.actual_account_name }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.company_registration_number"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Registration Number:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.company_registration_number }}
          </div>
        </div>
    
        <div class="vx-row mb-6" v-if="viewAccountDescription.status">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Company Status:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.status }}
          </div>
        </div>
                <div class="vx-row mb-6" v-if="viewAccountDescription.company_category">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Company Category:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.company_category }}
          </div>
        </div>
        <div v-if="viewAccountDescription.registered_office_address_1 || viewAccountDescription.registered_office_address_2 || viewAccountDescription.registered_office_address_3 || viewAccountDescription.registered_office_city || viewAccountDescription.registered_office_county || viewAccountDescription.registered_office_country || viewAccountDescription.registered_office_country">
<vs-divider class="m-5" />
        <!-- Registered Office -->
        <h5 class="mb-5 font-bold">Registered Office Address</h5>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_address_1"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold">Address Line 1:</span>
             
            
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_address_1 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_address_2"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Address Line 2:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_address_2 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_address_3"
        >
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              Address Line 3:</span
            >
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_address_3 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_city"
        >
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              City:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_city }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_county"
        >
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              County:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_county }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_postcode"
        >
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              Postcode:</span
            >
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_postcode }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_country"
        >
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              Country:</span
            >
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_country }}
          </div>
        </div>

        <!-- Head Office -->
        <div v-if="viewAccountDescription.head_office_address_1 || viewAccountDescription.head_office_address_2 || viewAccountDescription.head_office_address_3 || viewAccountDescription.head_office_city || viewAccountDescription.head_office_county || viewAccountDescription.head_office_postcode || viewAccountDescription.head_office_country">
                <vs-divider class="m-5" />
        <h5 class="mb-5 font-bold">Head Office Address</h5>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.head_office_address_1"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Address Line 1:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_address_1 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.head_office_address_2"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Address Line 2:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_address_2 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.head_office_address_3"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Address Line 3:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_address_3 }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_city">
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              City:</span
            >
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_city }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_county">
          <div class="vx-col sm:w-1/3 w-full">
<span class="font-bold"
              >             
              County:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_county }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_postcode">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Postcode:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_postcode }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_country">
    <div class="vx-col sm:w-1/3 w-full">
     <span class="font-bold"
              >
        
        Country:
      </span>
    </div>
    <div class="vx-col sm:w-2/3 w-full">
      {{ viewAccountDescription.head_office_country }}
    </div>
  </div>
        <!-- <vs-divider class="m-5" /> -->
        <template
          v-if="viewAccountDescription.web && viewAccountDescription.web.length > 0"
        >
          <div class="vx-row p-5">
            <h6 class="mr-5 font-bold">
             
              Company Website(s)
            </h6>
      
          </div>
          <div
            v-for="(website, web_key) in viewAccountDescription.web"
            :key="web_key"
          >
            <span>
              <p>{{ website.url }}</p>
            </span>
          </div>
          <vs-divider class="m-5" />
        </template>

        <template
          v-if="
            viewAccountDescription.linkedin &&
              viewAccountDescription.linkedin.length > 0
          "
        >
          <div class="vx-row p-5">
            <h6 class="mr-5 font-bold">
             
              Social Media Pages
            </h6>
           
          </div>
          <div
            v-for="(link, linkedin_key) in viewAccountDescription.linkedin"
            :key="linkedin_key"
          >
            <span>
              <p>{{ link.url }}</p>
            </span>
          </div>
          <vs-divider class="m-5" />
        </template>

        <!-- Site Office -->
        <template
          v-if="
            viewAccountDescription.satellite_office &&
              viewAccountDescription.satellite_office.length > 0
          "
        >
          <h5 class="mb-5 font-bold">Site Office Address</h5>
          <template
            v-for="(site, index) in viewAccountDescription.satellite_office"
          >
            <div :key="index">
              <vs-divider class="m-5" />
              <h6 class="mb-5 font-bold">{{ "Satellite Office " + (index + 1) }}</h6>
              <div class="vx-row mb-6" v-if="site.address_1">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    Address Line 1:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.address_1 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.address_2">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    Address Line 2:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.address_2 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.address_3">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    Address Line 3:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.address_3 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.city">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    City:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.city }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.county">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    County:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.county }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.postcode">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    Postcode:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.postcode }}</div>
              </div>
                <div class="vx-row mb-6" v-if="site.country">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                    Country:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.country }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.phone.length != 0">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"
              >
                   
                    Telephone:</span
                  >
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <template v-for="(phone, key) in site.phone">
                    <div :key="key" v-if="phone.satellite_office_id == site.id">
                      {{ phone.phone_code }} - {{ phone.phone_no }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
                  <vs-divider class="m-5" />
        </template>

        <!-- Telephone -->
        <template
          v-if="viewAccountDescription.phone && viewAccountDescription.phone.length > 0"
        >
          <div class="vx-row p-5">
            <h6 class="mr-5 font-bold">
              
              Telephone Number(s)
            </h6>
           
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <template v-for="phone in viewAccountDescription.phone">
                <template v-for="p_type in phone.phone_type">
                  <template v-if="phone.id == p_type.phone_id">
                    <!-- <template v-if="p_type.type == 'head_office_switchboard'"> -->
                      <p class="m-2">

                        {{p_type.type}} : {{ phone.phone_code }}{{ phone.phone_no }} 
                        <span v-if="phone.checked_status == 'Registered'" class="tps-registered" style="font-size:20px;" title="TPS Registered">®</span> 

                      </p>
                    <!-- </template>
                    <template v-if="p_type.type == 'customer_service'">
                      <p class="m-10">
                        Customer Service - {{ phone.phone_no }}
                      </p>
                    </template>

                    <template v-if="p_type.type == 'sales_line'">
                      <p class="m-10">Sales Line - {{ phone.phone_no }}</p>
                    </template>

                    <template v-if="p_type.type == 'customer_support_line'">
                      <p class="m-10">
                        Customer Support Line - {{ phone.phone_no }}
                      </p>
                    </template> -->
                  </template>
                </template>
              </template>
            </div>
            <div class="vx-col sm:w-2/3 w-full"></div>
          </div>
        </template>
        <!-- SIC CODE -->
         <template
          v-if="viewAccountDescription.sic_code && viewAccountDescription.sic_code.length > 0"
        >
          <div class="vx-row p-5">
            <h6 class="mr-5 font-bold">
             
              Sic Code(s)
            </h6>
          
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <template v-for="sic in viewAccountDescription.sic_code">
                <p  v-if="sic.sic_code_detail">
                  {{ sic.sic_code_detail.code }} {{ ' - ' +  sic.sic_code_detail.description }}
                </p>
              </template>
            </div>
            <div class="vx-col sm:w-2/3 w-full"></div>
          </div>
        </template>
        <template
          v-if="
            viewAccountDescription.registration_jurisdiction ||
              viewAccountDescription.parent ||
              viewAccountDescription.vertical
          "
        >
          <h5 class="mb-5">Other Details</h5>
          <div
            class="vx-row mb-6"
            v-if="viewAccountDescription.registration_jurisdiction"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-bold"
              >
                Registration Jurisdiction:</span
              >
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ RegistrationJurisdiction }}
              <!-- {{ viewAccountDescription.registration_jurisdiction }} -->
            </div>
          </div>
          <div class="vx-row mb-6" v-if="viewAccountDescription.parent">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-bold"
              >
                Parent:</span
              >
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ parent_name }}
            </div>
          </div>
          <div class="vx-row mb-6" v-if="viewAccountDescription.vertical">
            <div class="vx-col sm:w-1/3 w-full">
             <span class="font-bold"
              >
                Vertical:</span
              >
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <!-- {{ viewAccountDescription.vertical }} -->
              {{ verticalName }}
            </div>
          </div>
        </template>
        <div class="vx-row mb-6" v-if="viewAccountDescription.revenue">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Revenue:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.currency_name }} {{ viewAccountDescription.revenue }}
          </div>
        </div>
          <div class="vx-row mb-6" v-if="viewAccountDescription.no_of_employees">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              No of Employees:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.no_of_employees }} 
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.notes">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"
              >
              Notes:
            </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.notes }} 
          </div>
        </div>
       
      </div>

      <!-- <div class="text-center">

     <vs-button color="primary" @click="addEmail" type="filled"
                >Submit</vs-button
              >

              <vs-button color="primary" @click="addEmail" type="filled" class="ml-5"
                >Cancel</vs-button
              >

</div> -->
       

     
    </vs-popup>

        <form>
          <!-- {{ clientviewContactRecords }} -->

          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Select Account:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete
                ref="Grade3RebuildAccount"
                :key="companySearchComponentKey"
                :list="searchAccount"
                :searchOn="'company_or_registration_no'"
                @event-name="handleChildEvent"
              ></AccountAutocomplete>
            </div>


                  <div class="vx-col">
             <vs-icon
                  style="cursor: pointer"
                  @click="addNewAccount()"
                  icon="add_circle"
                  size="small"
                ></vs-icon>
            </div>

            <div class="vx-col">
            {{ contactDescription.company_name }}
            </div>

           

          </div>
          <!-- if satellite office is empty then contant lies on resitered office -->
          <div class="vx-row mb-6" v-if="showAddressField">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Address:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                name="satellite_address"
                label="satellite_address"
                :options="satellite_offices"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contactDescription.satellite_address"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Title:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="title"
                v-model="contactDescription.title"
                v-validate="'required'"
                data-vv-as="Title"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('title')"
              >{{ errors.first('title') }}</span
            >

            <div class="vx-col sm:w-1/3 w-full">
              <template v-for="(value, key, index) in clientviewContactRecords">
                <template
                  v-for="field_array_column in clientviewContactRecords[
                    'campaign_data_options'
                  ]"
                >
                  <template
                    v-if="
                      field_array_column.column_id == key &&
                      field_array_column.identifier == 'title'
                    "
                  >
                    {{ value }}
                  </template>
                </template>
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Forename:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="forename"
                data-vv-as="Forename"
                v-validate="'required'"
                v-model="contactDescription.forename"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('forename')"
              >{{ errors.first('forename') }}</span
            >
            <div class="vx-col sm:w-1/3 w-full ml-20">
              <template v-for="(value, key, index) in clientviewContactRecords">
                <template
                  v-for="field_array_column in clientviewContactRecords[
                    'campaign_data_options'
                  ]"
                >
                  <template
                    v-if="
                      field_array_column.column_id == key &&
                      field_array_column.identifier == 'forename'
                    "
                  >
                    {{ value }}
                  </template>
                </template>
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Surname:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="surname"
                data-vv-as="Surname"
                v-validate="'required'"
                v-model="contactDescription.surname"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('surname')"
              >{{ errors.first('surname') }}</span
            >
              <div class="vx-col sm:w-1/3 w-full ml-20">
              <template v-for="(value, key, index) in clientviewContactRecords">
                <template
                  v-for="field_array_column in clientviewContactRecords[
                    'campaign_data_options'
                  ]"
                >
                  <template
                    v-if="
                      field_array_column.column_id == key &&
                      field_array_column.identifier == 'surname'
                    "
                  >
                    {{ value }}
                  </template>
                </template>
              </template>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Job Title:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                v-validate="'required'"
                name="job_title"
                data-vv-as="Job Title"
                class="w-full"
                v-model="contactDescription.job_title"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('job_title')"
              >{{ errors.first('job_title') }}</span
            >
              <div class="vx-col sm:w-1/3 w-full ml-20">
              <template v-for="(value, key, index) in clientviewContactRecords">
                <template
                  v-for="field_array_column in clientviewContactRecords[
                    'campaign_data_options'
                  ]"
                >
                  <template
                    v-if="
                      field_array_column.column_id == key &&
                      field_array_column.identifier == 'job_title'
                    "
                  >
                    {{ value }}
                  </template>
                </template>
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Seniority:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                name="seniority"
                data-vv-as="Seniority"
                label="seniority"
                :options="contacts.seniorities"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contactDescription.seniority"
              />
            </div>
                <div class="vx-col sm:w-1/3 w-full ml-20">
              <template v-for="(value, key, index) in clientviewContactRecords">
                <template
                  v-for="field_array_column in clientviewContactRecords[
                    'campaign_data_options'
                  ]"
                >
                  <template
                    v-if="
                      field_array_column.column_id == key &&
                      field_array_column.identifier == 'seniority'
                    "
                  >
                    {{ value }}
                  </template>
                </template>
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                data-vv-as="Role"
                name="role"
                label="role"
                :options="contacts.roles"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contactDescription.role"
              />
            </div>
                <div class="vx-col sm:w-1/3 w-full ml-20">
              <template v-for="(value, key, index) in clientviewContactRecords">
                <template
                  v-for="field_array_column in clientviewContactRecords[
                    'campaign_data_options'
                  ]"
                >
                  <template
                    v-if="
                      field_array_column.column_id == key &&
                      field_array_column.identifier == 'role'
                    "
                  >
                    {{ value }}
                  </template>
                </template>
              </template>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Sub Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                data-vv-as="Sub Role"
                name="sub_role"
                label="sub_role"
                :options="contacts.sub_roles"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contactDescription.sub_role"
              />
            </div>
                <div class="vx-col sm:w-1/3 w-full ml-20">
              <template v-for="(value, key, index) in clientviewContactRecords">
                <template
                  v-for="field_array_column in clientviewContactRecords[
                    'campaign_data_options'
                  ]"
                >
                  <template
                    v-if="
                      field_array_column.column_id == key &&
                      field_array_column.identifier == 'sub_role'
                    "
                  >
                    {{ value }}
                  </template>
                </template>
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">Email</h5>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-button color="primary" @click="addEmail" type="filled"
                >Add</vs-button
              >
            </div>


                       <div class="vx-col sm:w-1/3 w-full ml-20">
              <template v-for="(value, key, index) in clientviewContactRecords">
                <template
                  v-for="field_array_column in clientviewContactRecords[
                    'campaign_data_options'
                  ]"
                >
                  <template
                    v-if="
                      field_array_column.column_id == key &&
                      field_array_column.identifier == 'email'
                    "
                  >
                         <template v-if="value == null || value == ''">

                

              </template>

              <template v-else>
              <template v-for="e in JSON.parse(value)" v-if="JSON.parse(value).length !== 0">
                <div class="flex mb-4">
                  {{ e.email }}
      
                </div>
              </template>


              <template v-else>
                
                
      
          </template>
          </template>
                  </template>
                </template>
              </template>
            </div>
          </div>


     

          

          <template v-for="(email, index) in contactDescription.emails">
            <div class="vx-row p-2">
              <div class="vx-col sm:w-1/6 w-full">
                <vs-input
                  class="w-full"
                  name="email"
                  v-model="email.email"
                  data-vv-as="Email"
                />
                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('email')"
                  >{{ errors.first('email') }}</span
                >
              </div>

              <div class="vx-col sm:w-1/6 w-full">
                <vs-icon
                  style="cursor: pointer"
                  @click="validateEmailZeroBounce(email.email)"
                  color="success"
                  icon="checkmark"
                ></vs-icon>

                <!-- <vs-radio
              v-model="email.primary"
              :vs-value="email.primary"
              class="mr-4"
              vs-name="primary_email"
            ></vs-radio
            > -->

                <vs-icon
                  class="removeButton"
                  @click="removeSelectedEmail(email)"
                  color="success"
                  icon="clear"
                >
                </vs-icon>
              </div>
            </div>
          </template>
          {{ email_validate_status }}

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">Social Media Pages</h5>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-button color="primary" @click="addSocialMedia" type="filled"
                >Add</vs-button
              >
            </div>



  <div class="vx-col sm:w-1/3 w-full ml-20">
              <template v-for="(value, key, index) in clientviewContactRecords">
                <template
                  v-for="field_array_column in clientviewContactRecords[
                    'campaign_data_options'
                  ]"
                >
                  <template
                    v-if="
                      field_array_column.column_id == key &&
                      field_array_column.identifier == 'contact_social_media'
                    "
                  >


              <template v-for="s in JSON.parse(value)" v-if="JSON.parse(value).length !== 0">
                <div class="flex mb-4">
                  {{ s.social_media }} {{ s.summary }}
      
                </div>
              </template>


              <template v-else>
                
                
      
          </template>
                
                  </template>
                </template>
              </template>
            </div>

          </div>

          <template
            v-for="(social_media, index) in contactDescription.social_medias"
          >
            <div class="vx-row">
              <div class="vx-col sm:w-1/6 w-full">
                <vs-input
                  class="w-full"
                  name="social_media"
                  v-model="social_media.social_media"
                  data-vv-as="Social Media"
                />
                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('social_media')"
                  >{{ errors.first('social_media') }}</span
                >
              </div>
              <div class="vx-col sm:w-1/6 w-full">
                <vs-textarea v-model="social_media.summary" />
              </div>

              <div class="vx-col sm:w-1/6 w-full">
                <!-- <vs-radio
              v-model="social_media.primary"
              :vs-value="social_media.primary"
              class="mr-4"
              vs-name="primary_social_media"
            ></vs-radio
            > -->

                <vs-icon
                  class="removeButton"
                  @click="removeSelectedSocialMedia(social_media)"
                  color="success"
                  icon="clear"
                >
                </vs-icon>
              </div>
            </div>
          </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">DDI</h5>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-button color="primary" @click="addDDI" type="filled"
                >Add</vs-button
              >
            </div>

<div class="vx-col sm:w-1/3 w-full ml-20">
              <template v-for="(value, key, index) in clientviewContactRecords">
                <template
                  v-for="field_array_column in clientviewContactRecords[
                    'campaign_data_options'
                  ]"
                >
                  <template
                    v-if="
                      field_array_column.column_id == key &&
                      field_array_column.identifier == 'ddi'
                    "
                  >


                <template v-if="value == null || value == ''">

                

              </template>

              <template v-else>
                

              <template v-for="d in JSON.parse(value)" v-if="JSON.parse(value).length !== 0">
                <div class="flex mb-4">
                  {{ d.ddi_phone_code }} {{ d.ddi }} 
      
                </div>
              </template>


              <template v-else>
                
                
      
          </template>
          </template>
                
                  </template>
                </template>
              </template>
            </div>

          </div>

          <template v-for="(ddi, index) in contactDescription.ddis">
            <div class="vx-row p-2">
              <div class="vx-col sm:w-1/6 w-full">
                <v-select
                  name="phone_code"
                  class="phone_code"
                  label="name_with_code"
                  :options="all_phone_codes"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="ddi.ddi_phone_code"
                />

                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('ddi')"
                  >{{ errors.first('ddi') }}</span
                >
              </div>
              <div class="vx-col sm:w-1/6 w-full">
                <vs-input
                  class="w-full"
                  name="ddi"
                  v-model="ddi.ddi"
                  data-vv-as="DDI"
                />
              </div>

              <div class="vx-col sm:w-1/6 w-full">
                <!-- <vs-radio
              v-model="ddi.primary"
              :vs-value="ddi.primary"
              class="mr-4"
              vs-name="primary_ddi"
            ></vs-radio
            > -->

                <vs-icon
                  class="removeButton"
                  @click="removeSelectedDDI(ddi)"
                  color="success"
                  icon="clear"
                >
                </vs-icon>
              </div>
            </div>
          </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">Mobile</h5>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-button color="primary" @click="addMobile" type="filled"
                >Add</vs-button
              >
            </div>


<div class="vx-col sm:w-1/3 w-full ml-20">
              <template v-for="(value, key, index) in clientviewContactRecords">
                <template
                  v-for="field_array_column in clientviewContactRecords[
                    'campaign_data_options'
                  ]"
                >
                  <template
                    v-if="
                      field_array_column.column_id == key &&
                      field_array_column.identifier == 'mobile'
                    "
                  >


              <template v-if="value == null || value == ''">

                

              </template>

              <template v-else>

              <template v-for="m in JSON.parse(value)" v-if="JSON.parse(value).length !== 0">
                <div class="flex mb-4">
                  {{ m.mobile_phone_code }} {{ m.mobile }}
      
                </div>
              </template>


              <template v-else>
                
                
      
          </template>
          </template>
                
                  </template>
                </template>
              </template>
            </div>


          </div>

          <template v-for="(mobile, index) in contactDescription.mobiles">
            <div class="vx-row p-2">
              <div class="vx-col sm:w-1/6 w-full">
                <v-select
                  name="phone_code"
                  class="phone_code"
                  label="name_with_code"
                  :options="all_phone_codes"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="mobile.mobile_phone_code"
                />

                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('mobile')"
                  >{{ errors.first('mobile') }}</span
                >
              </div>
              <div class="vx-col sm:w-1/6 w-full">
                <vs-input
                  class="w-full"
                  name="mobile"
                  v-model="mobile.mobile"
                  data-vv-as="Mobile"
                />
              </div>

              <div class="vx-col sm:w-1/6 w-full">
                <!-- <vs-radio
              v-model="mobile.primary"
              :vs-value="mobile.primary"
              class="mr-4"
              vs-name="primary_mobile"
            ></vs-radio
            > -->

                <vs-icon
                  class="removeButton"
                  @click="removeSelectedMobile(mobile)"
                  color="success"
                  icon="clear"
                >
                </vs-icon>
              </div>
            </div>
          </template>
          <vs-divider class="m-10" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from '@/components/aggrid/Aggrid.vue'
import defineAbilitiesFor from '@/config/abilities'
import moduleCampaignsManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import moduleAccountsManagement from '@/store/accounts-management/moduleAccountsManagement.js'
import moduleContactsManagement from '@/store/contacts-management/moduleContactsManagement.js'
import moduleSDSubStatusManagement from '@/store/sd-sub-status-management/moduleSDSubStatusManagement.js'
import vSelect from 'vue-select'
import AccountAutocomplete from '@/components/autocomplete/AccountsAutocomplete.vue'
export default {
  data () {
    return {
      isVisible: false,
      RegistrationJurisdiction: null,
      parent_name: null,
      verticalName: null,
            head_office_country_validation: null,

            selected_head_office_country: null,

            registered_office_country_validation: null,

            selected_registered_office_country: null,

      showAddAccountPopup: false,
      addAccountPopupActive: false,


            updateAccountDetailsPopupActive: false,

        showUpdateSAccountDetailsPopup: false,

      clientviewContactRecords: [],
      campaignDescription: [],

      temp_table_id: null,
      selected_status_notes: null,
      user_role_id: null,
      contact_sub_statuses: [],
      selected_contact_sub_status: [],

      please_choose_status: null,
      selected_status: null,

      all_sd_status: [],
      email_validate_status: null,

      all_phone_codes: [],
      previous_account_id: 0,
      editContactpopupActive: false,
      viewContactpopupActive: false,
      emailExistspopupActive: false,
      existsEmailseditContacts: [],
      edit_primary_email: null,
      viewContactDescription: {},
      editContactDescription: {},
      showEditAddressField: false,
      edit_satellite_offices: [],
      edit_account_validation: null,
      edit_accounts: [],
      companySearchComponentKey: 0,
      abilities: null,
      editContacts: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
        primary_ddi: null,

        edit_primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
        ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
        ddi: null,

        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: [],
        satellite_address: {},
        satellite_office_id: null
      },
      editContactShowPopup: false,
      records: [],
      new_added_email: 'fake@example.com',
      dataSource: {},
      abilities: null,
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'transactions',
          cellRenderer: 'CellRendererActions',
          suppressHeaderMenuButton: true,
          pinned: true,
          width: 120
        },
        {
          headerName: 'Company',
          field: 'company_name',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Address',
          field: 'address',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Title',
          field: 'title',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'ForeName',
          field: 'forename',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Surname',
          field: 'surname',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'DDI',
          field: 'ddi',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Job Title',
          field: 'job_title',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Email',
          field: 'email',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Mobile',
          field: 'mobile',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'DDI',
          field: 'ddi',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Seniority',
          field: 'seniority_name',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Social Media',
          field: 'social_media',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Role',
          field: 'role_name',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Sub Role',
          field: 'sub_role',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        }
      ],
      editContactpopupActive: false,
      viewContactpopupActive: false,
      emailExistspopupActive: false,
      existsEmailsContacts: [],
      primary_email: null,
      contactDescription: {},
      showAddressField: false,
      satellite_offices: [],
      account_validation: null,
       all_phone_codes: [],
      head_office_country_validation: null,
      companyExistsAccountDescription: {},
      selected_parent_company: null,
      selected_registration_jurisdiction: null,
      selected_vertical: null,
      selected_sic_code: null,
      selected_registered_office_country: null,
      selected_head_office_country: null,
      currencyCodes: [],
      abilities: null,
      currency_code_validation: null,

      registered_office_country_validation: null,
      accountDescription: [],
      accountExists: false,
      popupActive: false,
      websiteExists: false,
      linkedinExists: false,
      accounts: {
        company_name: null,
        registered_office_address_1: null,
        registered_office_address_2: null,
        registered_office_address_3: null,
        registered_office_city: null,
        registered_office_county: null,
        registered_office_postcode: null,
        registered_office_country: null,
        head_office_address_1: null,
        head_office_address_2: null,
        head_office_address_3: null,
        head_office_city: null,
        head_office_county: null,
        head_office_postcode: null,
        head_office_country: null,
        company_registration_number: null,
        registration_jurisdiction: null,
        company_category: null,
        status: null,
        parent: null,
        web: null,
        phone: null,
        phone_code: null,
        linkedin: null,
        country: null,
        main_counter: 0,
        satellite: [
          {
            counter: 0,
            address_1: null,
            address_2: null,
            address_3: null,
            city: null,
            county: null,
            postcode: null,
            country: null,
            phone: null,
            phone_code: null
          }
        ],
        IsSoleTrader: false,
        headOfficeIsRegisteredOffice: false,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        sicWithDescription: [],
        IsSoleTraderFields: {},
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null,
        notes: null,
        account_user_id: null,

      },
      companySearchComponentKey: 0,
      abilities: null,
      contacts: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
        primary_ddi: null,

        primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
        ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
        ddi: null,

        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: [],
        satellite_address: {},
        satellite_office_id: null
      }
    }
  },
  components: {
    'v-select': vSelect,
    AccountAutocomplete,
    DataGrid
  },
  created () {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })

    let userInfo = JSON.parse(localStorage.getItem('userInfo'))

    this.user_id = userInfo['uid']

    this.user_role_id = userInfo['roleId']

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule('contactsManagement', moduleContactsManagement)
      moduleContactsManagement.isRegistered = true
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        'campaignsManagement',
        moduleCampaignsManagement
      )
      moduleCampaignsManagement.isRegistered = true
    }

    if (!moduleSDSubStatusManagement.isRegistered) {
      this.$store.registerModule(
        'SDSubStatusManagement',
        moduleSDSubStatusManagement
      )
      moduleSDSubStatusManagement.isRegistered = true
    }
  },
  watch: {
     "accounts.IsSoleTrader"(val) {


      this.accounts.registered_office_country = this.$refs.accountAddRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.accounts.registered_office_country = this.$refs.accountAddRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.accounts.head_office_country = this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.value
      this.accounts.head_office_country = this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.input.value






      if (val) {
        this.accounts.IsSoleTraderFields = {
          company_name: this.accounts.company_name,
          head_office_country: this.accounts.head_office_country
        };


        if (this.accounts.head_office_country == null || this.accounts.head_office_country == '') {
          this.head_office_country_validation = 'The Head Office Country field is required'
          this.registered_office_country_validation = null
        } else {
          this.head_office_country_validation = null
        }



      } else {
        this.accounts.IsSoleTraderFields = {
          company_registration_number: this.accounts
            .company_registration_number,
          registered_office_country: this.accounts.registered_office_country
        };



        if (this.accounts.registered_office_country == null || this.accounts.registered_office_country == '') {
          this.registered_office_country_validation = 'The Registered Office Country field is required'
          this.head_office_country_validation = null
        } else {
          this.registered_office_country_validation = null
        }
      }



    },
    "accounts.headOfficeIsRegisteredOffice"(val) {
      if (val) {
        this.accounts.head_office_address_1 = this.accounts.registered_office_address_1;
        this.accounts.head_office_address_2 = this.accounts.registered_office_address_2;
        this.accounts.head_office_address_3 = this.accounts.registered_office_address_3;
        this.accounts.head_office_city = this.accounts.registered_office_city;
        this.accounts.head_office_county = this.accounts.registered_office_county;
        this.accounts.head_office_postcode = this.accounts.registered_office_postcode;
        // this.accounts.head_office_country = this.accounts.registered_office_country;


        if (moduleAccountsManagement.registered_office_country_selected) {
          this.selected_registered_office_country = moduleAccountsManagement.registered_office_country_selected
          this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.selected = moduleAccountsManagement.registered_office_country_selected
          this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.input.value = moduleAccountsManagement.registered_office_country_selected.name;
          this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.value = moduleAccountsManagement.registered_office_country_selected.name;
          this.accounts.head_office_country = moduleAccountsManagement.registered_office_country_selected.name;
        }



      } else {
        this.accounts.head_office_address_1 = null;
        this.accounts.head_office_address_2 = null;
        this.accounts.head_office_address_3 = null;
        this.accounts.head_office_city = null;
        this.accounts.head_office_county = null;
        this.accounts.head_office_postcode = null;

        this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.selected = null
        this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.input.value = null
        this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.value = null
        this.accounts.head_office_country = null;
      }
    },
    selected_status (val) {
      if (val) {
        console.log('STATUS CHANGED', this.user_role_id)
        this.fetchSDSubStatusByStatusIDAndRoleID(val.id, this.user_role_id)
      }
    },
    'contactDescription.role' (val) {
      if (val) {
        this.contacts.sub_roles = []
        if (val.id !== undefined) {
          this.getSubRole(val.id)
        }
      }
    },
    'editContactDescription.role' (val) {
      if (val) {
        this.editContacts.sub_roles = []
        if (val.id !== undefined) {
          this.getEditSubRole(val.id)
        }
      }
    }
  },
  beforeMount () {},
  mounted () {
    this.init()

    this.getCampaignDescription()

    this.getSeniority()
    this.getRoles()
    this.getEditSeniority()
    this.getEditRoles()
    this.getAllPhoneCodes()
    this.fetchAllSDStatus()

     this.getPhoneTypes();
    this.getCurrencyCodes()
    this.getAllPhoneCodes()

    // this.getVerticals();
  },
  methods: {
        acceptDuplicateWeb() {

      if (
        this.accounts.web &&
        !this.accounts.websites.includes(this.accounts.web)
      )
        this.accounts.websites.push(this.accounts.web);
      this.accounts.web = null

    },
    acceptDuplicateLinkedin() {

      if (
        this.accounts.linkedin &&
        !this.accounts.linkedins.includes(this.accounts.linkedin)
      )
        this.accounts.linkedins.push(this.accounts.linkedin);
      this.accounts.linkedin = null

    },
        accept() {
      this.popupActive = false
    },
    reject() {
      // this.popupActive = false;
      // this.$router.replace("/dashboard");
      this.$router.go(0);
    },
        getParentCompany(inputValue) {
      return this.$store
        .dispatch("accountsManagement/searchAutocomplete", inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)));
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    removeSelectedSiteAddress(site) {
      this.accounts.satellite = this.accounts.satellite.filter(item => {
        return item.counter != site.counter;
      });
    },
    addSiteOffice() {
      this.accounts.satellite.push({
        counter: ++this.accounts.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        country: null,
        phone: null,
        phone_code: null
      });
      // console.log(this.accounts.main_counter)
      // console.log(this.accounts.satellite)
    },

    removeSelectedLinkedin(url) {
      this.accounts.linkedins = this.accounts.linkedins.filter(item => {
        return item != url;
      });
    },
    removeSelectedPhone(selected) {
      this.accounts.joinedPhoneAndTypes = this.accounts.joinedPhoneAndTypes.filter(
        item => {
          return item != selected;
        }
      );
    },
    removeSelectedSic(selected) {
      this.accounts.joinedSicAndDescription = this.accounts.joinedSicAndDescription.filter(
        item => {
          return item != selected;
        }
      );
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) {
          return false;
        }
      }
      return true;
    },
    addPhoneNumbers() {
      if (
        this.accounts.phone &&
        this.accounts.phoneType &&
        !this.accounts.joinedPhoneAndTypes.includes(
         this.accounts.phoneType.name + ':' + this.accounts.phone_code.phone_code + " - " + this.accounts.phone
        )
      )
        this.accounts.joinedPhoneAndTypes.push(
          this.accounts.phoneType.name + ':' + this.accounts.phone_code.phone_code + " - " + this.accounts.phone 
        );
      let mappedPhoneTypes = {};
      mappedPhoneTypes.phone_code = this.accounts.phone_code.phone_code;
      mappedPhoneTypes.phone_no = this.accounts.phone;
      mappedPhoneTypes.phone_type = this.accounts.phoneType.slug;
      this.accounts.phoneWithTypes.push(mappedPhoneTypes);
      this.accounts.phone = null;
      this.accounts.phone_code = null;
      this.accounts.phoneType = null;
    },
    addSicCode() {
      // if (
      //   this.accounts.sic_code &&
      //   this.accounts.sic_code_description &&
      //   !this.accounts.joinedSicAndDescription.includes(
      //     this.accounts.sic_code + " - " + this.accounts.sic_code_description
      //   )
      // )
      //   this.accounts.joinedSicAndDescription.push(
      //     this.accounts.sic_code + " - " + this.accounts.sic_code_description
      //   );
      // let mappedSic = {};
      // mappedSic.code = this.accounts.sic_code;
      // mappedSic.description = this.accounts.sic_code_description;

      this.accounts.joinedSicAndDescription.push(
        moduleAccountsManagement.sic_codes_selected.name
      );


      // console.log(moduleAccountsManagement.sic_codes_selected)
      this.accounts.sicWithDescription.push(moduleAccountsManagement.sic_codes_selected);

      this.$refs.SicCodeRef.$refs.suggestComponent.selected = null
      this.$refs.SicCodeRef.$refs.suggestComponent.input.value = null
      this.$refs.SicCodeRef.$refs.suggestComponent.value = null
      // this.selected_sic_code = null
      // this.accounts.sic_code = null;
      // this.accounts.sic_code_description = null;
    },
    addWebsite() {

      if (this.validDomain(this.accounts.web)) {
        this.$store
          .dispatch("accountsManagement/checkWebsiteExists", this.accounts.web)
          .then(res => {



            if (res.data.status == "fail") {
              this.websiteExists = true;
              this.$vs.dialog({
                type: 'confirm',
                color: "primary",
                title: `Confirm`,
                text: "This value is already associated with " + res.data.data.company_name + ", do you wish to continue adding this value to this company as well?",
                accept: this.acceptDuplicateWeb
              });
              // var index = this.accounts.websites.indexOf(lastItem);
              // this.accounts.websites.splice(index, 1);
            } else {
              if (
                this.accounts.web &&
                !this.accounts.websites.includes(this.accounts.web)
              )
                this.accounts.websites.push(this.accounts.web);
              this.accounts.web = null
            }
          })
          .catch(err => {
            if (err.response.status === 401) {
              this.$router.replace("/login");
            }
          });
      }











      // this.accounts.web = null;
    },
    addLinkedin() {


      this.$store
        .dispatch("accountsManagement/checkLinkedinExists", this.accounts.linkedin)
        .then(res => {
          if (res.data.status == "fail") {
            this.linkedinExists = true;
            this.$vs.dialog({
              type: 'confirm',
              color: "primary",
              title: `Confirm`,
              text: "This value is already associated with " + res.data.data.company_name + ", do you wish to continue adding this value to this company as well?",
              accept: this.acceptDuplicateLinkedin
            });
          } else {
            if (
              this.accounts.linkedin &&
              !this.accounts.linkedins.includes(this.accounts.linkedin)
            )
              this.accounts.linkedins.push(this.accounts.linkedin);
            this.accounts.linkedin = null;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });





    },
    addAccountForm() {


      this.accounts.registered_office_country = this.$refs.accountAddRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.accounts.registered_office_country = this.$refs.accountAddRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.accounts.head_office_country = this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.value
      this.accounts.head_office_country = this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.input.value




      this.accounts.account_user_id = this.user_id




      this.$validator.validateAll('AddAccountForm').then(result => {
        if (result) {
          if (Object.keys(this.accounts.IsSoleTraderFields).length === 0) {
            this.accounts.IsSoleTraderFields = {
              company_registration_number: this.accounts
                .company_registration_number,
              registered_office_country: this.accounts.registered_office_country
            };
          } else {

            this.accounts.IsSoleTraderFields = {
              company_name: this.accounts.company_name,
              head_office_country: this.accounts.head_office_country
            };

          }





          if (this.accounts.IsSoleTrader) {
            this.accounts.IsSoleTraderFields = {
              company_name: this.accounts.company_name,
              head_office_country: this.accounts.head_office_country
            };

            if (this.accounts.head_office_country == null || this.accounts.head_office_country == '') {
              this.head_office_country_validation = 'The Head Office Country field is required'
              this.registered_office_country_validation = null
              return false
            } else {
              this.head_office_country_validation = null
            }



          } else {
            this.accounts.IsSoleTraderFields = {
              company_registration_number: this.accounts
                .company_registration_number,
              registered_office_country: this.accounts.registered_office_country
            };


            if (this.accounts.registered_office_country == null || this.accounts.registered_office_country == '') {
              this.registered_office_country_validation = 'The Registered Office Country field is required'
              this.head_office_country_validation = null
              return false
            } else {
              this.registered_office_country_validation = null
            }

          }







          if (moduleAccountsManagement.autocomplete_selected) {
            this.accounts.parent =
              moduleAccountsManagement.autocomplete_selected.id;
          }
          if (moduleAccountsManagement.vertical_selected) {
            this.accounts.vertical =
              moduleAccountsManagement.vertical_selected.id;
          }
          if (moduleAccountsManagement.countries_selected) {
            this.accounts.registration_jurisdiction =
              moduleAccountsManagement.countries_selected.id;
          }
          if (moduleAccountsManagement.head_office_country_selected) {
            this.accounts.head_office_country =
              moduleAccountsManagement.head_office_country_selected.name;
          }

          if (moduleAccountsManagement.registered_office_country_selected) {
            this.accounts.registered_office_country =
              moduleAccountsManagement.registered_office_country_selected.name;
          }






          if (this.accounts.revenue != null && this.accounts.currency_code == null) {
            this.currency_code_validation = 'The currency code field is required'
            return false
          }



          this.addAccounts();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    addAccounts() {
      this.$store
        .dispatch("accountsManagement/addAccount", this.accounts)
        .then(res => {
          if (res.data.status == "fail") {
            this.checkCompanyExists()
            this.$vs.notify({
              color: "danger",
              title: "Account",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Account",
              text: res.data.message
            });
            



            let addedAccount = res.data.data

                 
             this.contactDescription.account_id = addedAccount.id
              this.contactDescription.account_name = addedAccount.company_name
      this.$refs.Grade3RebuildAccount.$refs.suggestComponent.input.value =
        addedAccount.company_name
      this.$refs.Grade3RebuildAccount.$refs.suggestComponent.value =
        addedAccount.company_name

        this.showAddAccountPopup = false;
            this.addAccountPopupActive = false;


        this.showUpdateSAccountDetailsPopup = false
      this.updateAccountDetailsPopupActive = false
 


            
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    checkCompanyExists() {
      if (this.accounts.IsSoleTrader) {
        this.accounts.IsSoleTraderFields = {
          company_name: this.accounts.company_name,
          head_office_country: this.accounts.head_office_country
        };
      } else {
        this.accounts.IsSoleTraderFields = {
          company_registration_number: this.accounts
            .company_registration_number,
          registered_office_country: this.accounts.registered_office_country
        };
      }
      this.accounts.IsSoleTraderFields.is_sole_trader = this.accounts.IsSoleTrader
      this.$store
        .dispatch(
          "accountsManagement/checkCompanyExists",
          this.accounts.IsSoleTraderFields
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.companyExistsAccountDescription = res.data.data;


          this.showAddAccountPopup = false
          this.addAccountPopupActive = false


            this.accountExists = true;
            this.popupActive = true;





          } else {
            return;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getPhoneTypes() {
      this.$store
        .dispatch("accountsManagement/getPhoneTypes")
        .then(res => {
          this.accounts.phoneTypes = res.data;
          this.accounts.phoneTypes = this.accounts.phoneTypes.filter(
            item => item.name != "Site Switchboard"
          );
          // console.log(this.accounts.phoneTypes)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getVerticals(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getVerticals", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.verticals;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCurrencyCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCurrencyCodes")
        .then(response => {
          let response_data = response.data
          let mappedArray = [];
          for (const property in response_data) {
            mappedArray.push({
              id: response_data[property].id,
              label: response_data[property].symbol + ' ' + response_data[property].name + ' ' + response_data[property].code
            });
          }
          this.currencyCodes = mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getSicCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getSicCodes", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.sic_codes;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].code + ' - ' + data[property].description
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
      closUpdateSAccountDetailsPopup (value) {
      if (!value) this.updateAccountDetailsPopupActive = true
    },
      showParentName(parentId) {
      this.$store
        .dispatch("accountsManagement/getParent", parentId)
        .then(res => {
          this.parent_name = res.data.company_name;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true;
            return;
          }
          console.error(err);
        });
    },
    showRegistrationJurisdiction(countryId) {
      this.$store
        .dispatch("accountsManagement/getCountry", countryId)
        .then(res => {
          this.RegistrationJurisdiction = res.data.name_1;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true;
            return;
          }
          console.error(err);
        });
    },

    showVertical(verticalId) {
      this.$store
        .dispatch("accountsManagement/getVertical", verticalId)
        .then(res => {
          this.verticalName = res.data.vertical;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
      viewAccountDetails (accountId) {
      this.$store
        .dispatch('accountsManagement/fetchAccount', accountId)
        .then(res => {
          this.viewAccountDescription = res.data


      if (this.viewAccountDescription.parent) {
            this.showParentName(this.viewAccountDescription.parent);
          }
          if (this.viewAccountDescription.registration_jurisdiction) {
            this.showRegistrationJurisdiction(
              this.viewAccountDescription.registration_jurisdiction
            );
          }
          if (this.viewAccountDescription.vertical) {
            this.showVertical(this.viewAccountDescription.vertical);
          }



             this.showUpdateSAccountDetailsPopup = true
          this.updateAccountDetailsPopupActive = true




          
        })
        .catch(err => {
          console.error(err)
        })
    },
    addNewAccount () {

       this.accounts = {
        company_name: null,
        registered_office_address_1: null,
        registered_office_address_2: null,
        registered_office_address_3: null,
        registered_office_city: null,
        registered_office_county: null,
        registered_office_postcode: null,
        registered_office_country: null,
        head_office_address_1: null,
        head_office_address_2: null,
        head_office_address_3: null,
        head_office_city: null,
        head_office_county: null,
        head_office_postcode: null,
        head_office_country: null,
        company_registration_number: null,
        registration_jurisdiction: null,
        company_category: null,
        status: null,
        parent: null,
        web: null,
        phone: null,
        phone_code: null,
        linkedin: null,
        country: null,
        main_counter: 0,
        satellite: [
          {
            counter: 0,
            address_1: null,
            address_2: null,
            address_3: null,
            city: null,
            county: null,
            postcode: null,
            country: null,
            phone: null,
            phone_code: null
          }
        ],
        IsSoleTrader: false,
        headOfficeIsRegisteredOffice: false,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        sicWithDescription: [],
        IsSoleTraderFields: {},
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null,
        notes: null,
        account_user_id: null,

      }


      this.getPhoneTypes()
       this.getCurrencyCodes()
       this.getAllPhoneCodes()

       moduleAccountsManagement.autocomplete_selected = null
       moduleAccountsManagement.vertical_selected = null
       moduleAccountsManagement.countries_selected = null
       moduleAccountsManagement.head_office_country_selected = null
       moduleAccountsManagement.registered_office_country_selected = null



      this.showAddAccountPopup = true
      this.addAccountPopupActive = true
    },
    getCampaignDescription () {
      const campaignId = this.$route.params.campaignId
      this.$store
        .dispatch('campaignsManagement/fetchCampaign', campaignId)
        .then(res => {
          this.campaignDescription = res.data
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true
            return
          }
          console.error(err)
        })
    },
    fetchSDSubStatusByStatusIDAndRoleID (status_id, role_id) {
      let self = this
      this.$store
        .dispatch('SDSubStatusManagement/fetchSDSubStatusByStatusIDAndRoleID', {
          status_id: status_id,
          role_id: role_id
        })
        .then(res => {
          let result = JSON.parse(res.data)

          self.contact_sub_statuses = []

          result.forEach(function (ele) {
            if (ele.level == 'contact') {
              self.contact_sub_statuses.push(ele)
            }
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
    fetchAllSDStatus () {
      this.$store
        .dispatch('campaignsManagement/fetchAllSDStatus')
        .then(res => {
          let result = res.data

          result = result.filter(function (ele) {
            return ele.status != 'rebuild'
          })

          this.all_sd_status = result
        })
        .catch(err => {
          console.error(err)
        })
    },
    getAllPhoneCodes () {
      let self = this
      this.$store
        .dispatch('accountsManagement/getAllPhoneCodes')
        .then(response => {
          self.all_phone_codes = response.data
          self.all_phone_codes.forEach(function (ele) {
            if (ele.phone_code) {
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },

    searchEditAccount (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getCompanyOrRegistrationNo', inputValue)
        .then(response => {
          if (response) {
            let data = moduleAccountsManagement.state.company_or_registration_no
            if (data) {
              // console.log(data);
              let mappedArray = []
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    ' - ' +
                    data[property].company_registration_number
                })
              }
              return mappedArray
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    validDomain (userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        )
        if (res == null) {
          return false
        }
      }
      return true
    },
    editSubmitForm () {
      // console.log(this.editContactDescription)
      // return false

      let self = this
      if (this.editContactDescription.edit_primary_email) {
        this.editContactDescription.primary_email =
          this.editContactDescription.edit_primary_email
      }
      // if (
      //   self.edit_accounts.length === 0 &&
      //   self.editContactDescription.company_name == null
      // ) {
      //   self.edit_account_validation = "The Account field is required";
      //   return false;
      // } else {
      //   if (self.edit_accounts.length != 0) {
      //     self.editContactDescription.account_id = self.edit_accounts[0].id;
      //   }
      //   self.updateEditContact();
      // }

      this.$validator.validateAll('popup-edit-form').then(result => {
        // console.log(this.editContactDescription.company_name);
        if (result) {
          if (
            self.edit_accounts.length === 0 &&
            self.editContactDescription.company_name == null
          ) {
            self.edit_account_validation = 'The Account field is required'
            return false
          } else {
            if (self.edit_accounts.length != 0) {
              self.editContactDescription.account_id = self.edit_accounts[0].id
            }
            self.updateEditContact()
          }

          // if form have no errors
        } else {
          return false
        }
      })
    },
    getEditSatelliteOffices (account_id) {
      let self = this
      self.$store
        .dispatch('accountsManagement/getSatelliteOffices', account_id)
        .then(res => {
          // console.log("sdfdfsdf", res.data);

          self.edit_satellite_offices = res.data
          if (self.edit_satellite_offices.length != 0) {
            self.showEditAddressField = true
            self.edit_satellite_offices.forEach(function (ele) {
              ele.satellite_address =
                ele.address_1 + ',' + ele.city + ',' + ele.county
              return ele
            })
          } else {
            self.showEditAddressField = false
          }
          // console.log(self.edit_satellite_offices);
        })
        .catch(err => {
          console.error(err)
        })
    },
    updateEditContact () {
      if (Array.isArray(this.editContactDescription.role)) {
        this.editContactDescription.role = this.editContactDescription.role[0]
      }

      if (Array.isArray(this.editContactDescription.sub_role)) {
        this.editContactDescription.sub_role =
          this.editContactDescription.sub_role[0]
      }

      if (Array.isArray(this.editContactDescription.seniority)) {
        this.editContactDescription.seniority =
          this.editContactDescription.seniority[0]
      }

      // if (Array.isArray(this.editContactDescription.job_title)) {
      //   this.editContactDescription.job_title = this.editContactDescription.job_title[0];
      // }

      //       console.log("sfsdfsdf" , this.editContactDescription)
      // return false

      if (Object.keys(this.editContacts.satellite_address).length != 0) {
        this.editContactDescription.satellite_office_id =
          this.editContacts.satellite_address.uuid
      } else {
        this.editContactDescription.satellite_office_id = null
      }
      this.$store
        .dispatch(
          'contactsManagement/updateContact',
          this.editContactDescription
        )
        .then(res => {
          if (res.data.status == 'success') {
            this.$refs.EditEmailExistsInDb.gridApi.refreshServerSide({
              purge: true
            })

            this.editContactShowPopup = false
          }
        })
        .catch(err => {
          console.error(err)
        })
    },

    viewContactDetails (contactId) {
      this.$store
        .dispatch('contactsManagement/fetchContact', contactId)
        .then(res => {
          this.viewContactDescription = res.data
          this.viewContactpopupActive = true
        })
        .catch(err => {
          console.error(err)
        })
    },
    viewContactpopup (contact) {
      this.viewContactDetails(contact.contact_id)
    },
    closeThisWindow () {
      let self = this
      self.viewContactpopupActive = false
    },
    removeSelectedSocialMedia (social_media) {
      this.contactDescription.social_medias =
        this.contactDescription.social_medias.filter(item => {
          return item != social_media
        })
    },
    removeSelectedEmail (email) {
      this.contactDescription.emails = this.contactDescription.emails.filter(
        item => {
          return item != email
        }
      )
    },
    removeSelectedMobile (mobile) {
      this.contactDescription.mobiles = this.contactDescription.mobiles.filter(
        item => {
          return item != mobile
        }
      )
    },
    removeSelectedDDI (ddi) {
      this.contactDescription.ddis = this.contactDescription.ddis.filter(
        item => {
          return item != ddi
        }
      )
    },
    handleChildEvent () {
     // this.satellite_offices = []
      this.accounts = moduleAccountsManagement.state.accounts.datas
     // this.contactDescription.account_id = this.accounts[0].id
     // this.getSatelliteOffices(this.accounts[0].id)


      this.viewAccountDetails(this.accounts[0].id)
    },
    searchAccount (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getCompanyOrRegistrationNo', inputValue)
        .then(response => {
          if (response) {
            let data = moduleAccountsManagement.state.company_or_registration_no
            if (data) {
              // console.log(data);
              let mappedArray = []
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    ' - ' +
                    data[property].company_registration_number
                })
              }
              return mappedArray
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getEditSeniority () {
      this.$store
        .dispatch('contactsManagement/getSeniority')
        .then(res => {
          this.editContacts.seniorities = res.data
          // console.log(this.editContacts.seniorities);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getEditRoles () {
      this.$store
        .dispatch('contactsManagement/getRoles')
        .then(res => {
          this.editContacts.roles = res.data
          // console.log("Roles", this.editContacts.roles);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getEditSubRole (role_id) {
      // alert(role_id)
      // if(!role_id){
      // this.editContactDescription.sub_role = null

      // }
      this.$store
        .dispatch('contactsManagement/getSubRoles', role_id)
        .then(res => {
          this.editContacts.sub_roles = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    getSeniority () {
      this.$store
        .dispatch('contactsManagement/getSeniority')
        .then(res => {
          this.contacts.seniorities = res.data
          // console.log(this.contacts.seniorities);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getRoles () {
      this.$store
        .dispatch('contactsManagement/getRoles')
        .then(res => {
          this.contacts.roles = res.data
          // console.log("Roles", this.contacts.roles);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getSubRole (role_id) {
      // alert(role_id)
      // if(!role_id){
      // this.contactDescription.sub_role = null

      // }
      this.$store
        .dispatch('contactsManagement/getSubRoles', role_id)
        .then(res => {
          this.contacts.sub_roles = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    goBack: function () {
      this.$router.push({
        path:
          '/data_build/grade_3_contacts_rebuild_for_data_administration/' +
          this.$route.params.campaignId
      })
    },
    removeSelectedPhone (selected) {
      this.contacts.joinedPhoneAndTypes =
        this.contacts.joinedPhoneAndTypes.filter(item => {
          return item != selected
        })
    },
    validDomain (userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        )
        if (res == null) {
          return false
        }
      }
      return true
    },
    cancelAccountSelection () {
      this.contactDescription.account_id = this.previous_account_id
      this.$refs.Grade3RebuildAccount.$refs.suggestComponent.input.value =
        this.contactDescription.account_name
      this.$refs.Grade3RebuildAccount.$refs.suggestComponent.value =
        this.contactDescription.account_name
      this.showUpdateSAccountDetailsPopup = false
      this.updateAccountDetailsPopupActive = false

      
    },
    confirmAccountSelection () {


       this.satellite_offices = []
      this.accounts = moduleAccountsManagement.state.accounts.datas
      this.contactDescription.account_id = this.accounts[0].id
      this.getSatelliteOffices(this.accounts[0].id)

      this.showUpdateSAccountDetailsPopup = false
      this.updateAccountDetailsPopupActive = false
    },
    // addEmail() {
    //   console.log("New Email" , this.contactDescription.email)
    //   if (
    //     this.contactDescription.email &&
    //     !this.contactDescription.emails.includes(this.contactDescription.email)
    //   )
    //     this.contactDescription.emails.push({
    //       email: this.contactDescription.email
    //     });
    //   this.contactDescription.email = null;

    //   console.log("Emails", this.contactDescription.emails);
    // },
    validateEmailZeroBounce (email) {
      let self = this

      self.$vs.loading()

      this.$store
        .dispatch('contactsManagement/validateEmailZeroBounce', email)
        .then(res => {
          self.email_validate_status = res.data
          self.$vs.loading.close()

          console.log(res)
        })
        .catch(err => {
          console.error(err)
        })
    },
    addSocialMedia () {
      this.contactDescription.social_medias.push({
        social_media: null,
        summary: null,
        primary: false
      })
    },
    addEmail () {
      this.contactDescription.emails.push({
        email: null,
        primary: false
      })
    },
    addDDI () {
      this.contactDescription.ddis.push({
        ddi: null,
        ddi_phone_code: null,
        primary: false
      })
    },
    addMobile () {
      this.contactDescription.mobiles.push({
        mobile: null,
        mobile_phone_code: null,
        primary: false
      })
    },
    submitForm () {
      // console.log(this.contactDescription)
      // return false

      let self = this
      self.updateContact()
    },
    getSatelliteOffices (account_id) {
      let self = this
      self.$store
        .dispatch('accountsManagement/getSatelliteOffices', account_id)
        .then(res => {
          // console.log("sdfdfsdf", res.data);

          self.satellite_offices = res.data
          if (self.satellite_offices.length != 0) {
            self.showAddressField = true
            self.satellite_offices.forEach(function (ele) {
              ele.satellite_address =
                ele.address_1 + ',' + ele.city + ',' + ele.county
              return ele
            })
          } else {
            self.showAddressField = false
          }
          // console.log(self.satellite_offices);
        })
        .catch(err => {
          console.error(err)
        })
    },

    viewClientUserContactRecords (contact) {
      let self = this

      let data = {}
      data.contact_id = contact.contact_id
      data.campaign_id = contact.campaign_id
      self.selectedEditCampaignId = contact.campaign_id
      self.selectedEditContactId = contact.contact_id

      self.selected_sd_account_id = contact.account_id
      self.selected_account_id = contact.account_id

      self.$store
        .dispatch('accountsManagement/getClientViewContactForGrade3Rebuild', data)
        .then(res => {
          if (res.data) {
            self.clientviewContactRecords = JSON.parse(res.data)

            console.log('Contact', self.clientviewContactRecords)
          }
        })
        .catch(err => {
          console.log(err)
        })

      // var array = ["id","acc_id","campaign_id","contact_campaign_id","contact_id","contact_status","contact_id", "contact_status","contact_web"];
      // this.clientviewContactRecords = this.deleteKeys(contact, array);
      // console.log("Contact", this.clientviewContactRecords);
    },
    init () {
      let self = this
      let data = {}
      data.account_id = this.$route.params.accountId
      data.contact_id = this.$route.params.contactId
      self.$store
        .dispatch('contactsManagement/fetchGrade3ContactForRebuild', data)
        .then(res => {
          self.contactDescription = res.data

          self.viewClientUserContactRecords(self.contactDescription)

          console.log('contactDescription', self.contactDescription)

          self.temp_table_id = this.$route.params.tableId

          self.previous_account_id = self.contactDescription.account_id

          self.$refs.Grade3RebuildAccount.$refs.suggestComponent.input.value =
            self.contactDescription.account_name
          self.$refs.Grade3RebuildAccount.$refs.suggestComponent.value =
            self.contactDescription.account_name

          console.log(
            'Contact Description',
            self.contactDescription.account_name
          )
          // console.log(
          //   "Previous Account Contact Description",
          //   self.contactDescription
          // );

          if (self.contactDescription.selected_satellite_office) {
            self.contactDescription.satellite_address =
              self.contactDescription.selected_satellite_office
            self.getSatelliteOffices(self.contactDescription.account_id)
          }

          if (self.contactDescription.role) {
            self.contactDescription.role.forEach(function (ele) {
              ele.id = ele.uuid
              return ele
            })
          }

          if (self.contactDescription.sub_role) {
            self.contactDescription.sub_role.forEach(function (ele) {
              ele.id = ele.uuid
              return ele
            })
          }

          if (self.contactDescription.seniority) {
            self.contactDescription.seniority.forEach(function (ele) {
              ele.id = ele.uuid
              return ele
            })
          }

          if (self.contactDescription.emails) {
            self.contactDescription.emails.forEach(function (ele) {
              if (ele.primary == true) {
                self.contactDescription.primary_email = ele.email
              }
              return ele
            })
          }

          if (self.contactDescription.social_medias) {
            self.contactDescription.social_medias.forEach(function (ele) {
              if (ele.primary == true) {
                self.contactDescription.primary_social_media = ele.social_media
              }
              return ele
            })
          }

          if (self.contactDescription.mobiles) {
            self.contactDescription.mobiles.forEach(function (ele) {
              if (ele.primary == true) {
                self.contactDescription.primary_mobile = ele.mobile
              }
              return ele
            })
          }

          if (self.contactDescription.ddis) {
            self.contactDescription.ddis.forEach(function (ele) {
              if (ele.primary == true) {
                self.contactDescription.primary_ddi = ele.ddi
              }
              return ele
            })
          }

          if (self.contactDescription.job_title) {
            self.contactDescription.job_title =
              self.contactDescription.job_title[0]['job_title']
          }

          self.getSubRole(self.contactDescription.role && self.contactDescription.role[0] && self.contactDescription.role[0].id)



          // this.contactDescription.webShow = this.contactDescription.web.slice(
          //   0,
          //   this.website_show_no
          // );
          // this.contactDescription.linkedinShow = this.contactDescription.linkedin.slice(
          //   0,
          //   this.linkedin_show_no
          // );
          // this.contactDescription.phone = this.contactDescription.phone.slice(
          //   0,
          //   this.telephone_show_no
          // );
        })
        .catch(err => {
          console.error(err)
        })
    },
    updateContact () {
      if (Array.isArray(this.contactDescription.role)) {
        this.contactDescription.role = this.contactDescription.role[0]
      }

      if (Array.isArray(this.contactDescription.sub_role)) {
        this.contactDescription.sub_role = this.contactDescription.sub_role[0]
      }

      if (Array.isArray(this.contactDescription.seniority)) {
        this.contactDescription.seniority = this.contactDescription.seniority[0]
      }


      if (Object.keys(this.contacts.satellite_address).length != 0) {
        this.contactDescription.satellite_office_id =
          this.contacts.satellite_address.uuid
      } else {
        this.contactDescription.satellite_office_id = null
      }

      this.contactDescription.previous_account_id = this.previous_account_id
      this.contactDescription.uuid = this.$route.params.contactId
      this.contactDescription.user_id = this.user_id
      this.contactDescription.table_id = this.$route.params.tableId



      this.$store
        .dispatch(
          'contactsManagement/updateGrade3RebuildContact',
          this.contactDescription
        )
        .then(res => {
          if (res.data.status == 'success') {
            this.$vs.notify({
              color: 'success',
              title: 'Grade 3 Contact Rebuilt',
              text: 'The grade 3 contact was rebuilt successfully'
            })

            this.$router.push(
              '/data_build/grade_3_contacts_rebuild_for_data_administration/' +
                this.$route.params.campaignId
            )
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.searchbox {
  width: 582px;
}
</style>
